import './LessonPreviewer.less';
import React, {useState, useEffect} from 'react';
import VideoPlayer from "../../../components/video-player/VideoPlayer";
import Icon from "../../../../bootstrap/components/icon/Icon";
import __ from '../../../i18n';


export default function LessonPreviewer({previewLessons, videos, close}) {

    const [playingIndex, setPlayingIndex] = useState(0);

    const playingVideoId = previewLessons[playingIndex].video_id;

    const playingVideo = videos.find(v => v.id === playingVideoId);

    return <div className="lesson-previewer">
        <div className="heading">
            <h3 className="title">{__('Sample lessons')}</h3>
            <button
                type="button"
                className="close-button"
                onClick={() => close()}
            >
                <Icon name="times"/>
            </button>
        </div>

        <VideoPlayer
            video={playingVideo}
            autoPlay={true}
        />

        <div className="play-list">
            <ul>
                {
                    previewLessons.map((lesson, index) => {
                        return <li
                            key={index}
                            className={playingIndex === index ? 'active' : ''}
                            onClick={() => setPlayingIndex(index)}
                        >
                            <Icon name="play-circle"/>
                            <span className="text">{lesson.name}</span>
                        </li>;
                    })
                }
            </ul>
        </div>
    </div>;
}
